import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router, RouterModule } from '@angular/router';
import { HeaderLogoComponent } from "./widgets/header-logo/header-logo.component";
import { NavService } from '../../services/nav.service';
import { ToggleScreenComponent } from "./widgets/toggle-screen/toggle-screen.component";
import { SearchComponent } from "./widgets/search/search.component";
import { ModeComponent } from "./widgets/mode/mode.component";
import { ProfileComponent } from "./widgets/profile/profile.component";
import { SimulationStateService } from '../../services/simulation-state.service';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    RouterModule,
    HeaderLogoComponent,
    ToggleScreenComponent,
    SearchComponent,
    ModeComponent,
    ProfileComponent
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})

export class HeaderComponent implements OnInit {

  simulationEnabled = false;
  orgName = 'AeroVera IQ';

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private navService: NavService,
    private router: Router,
    private simulationState: SimulationStateService
  ) {}

  ngOnInit(): void {
    this.simulationEnabled = this.simulationState.enabled;

    try {
      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      this.orgName = userData?.OrgName?.trim() || 'AeroVera IQ';
    } catch {
      this.orgName = 'AeroVera IQ';
    }

    this.simulationState.state$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(state => {
        this.simulationEnabled = state.enabled;
      });
  }

  toggleLanguage() {
    this.navService.isLanguage =! this.navService.isLanguage;
  }

  openSearch() {
    this.navService.isSearchOpen = true;
  }

  goToSimulation(): void {
    this.router.navigate(['/settings/simulation']);
  }
}
